import { lazy, Suspense } from "react"

import { Card, Skeleton } from "@/atoms"

import type { AgentInventoryComponent } from "."

// Lazily load the inventory view so it ships as its own chunk — keeping it out of the bundle for
// users who never open this internal-only tab (mirrors AttackSimulation/AttackChains).
const AgentInventoryView = lazy(() => import("./components/AgentInventoryView"))

const AgentInventory: AgentInventoryComponent = (props) => (
  <Suspense
    fallback={
      <Card>
        <Skeleton active />
      </Card>
    }
  >
    <AgentInventoryView {...props} />
  </Suspense>
)

export default AgentInventory
